import type { TranslationKeys } from '@vocab/core';
import { useTranslations } from '@vocab/react';

import translations from '../.vocab';

export type IconLabelTranslationKeys = TranslationKeys<typeof translations>;

const labelToKeyMap: Record<string, IconLabelTranslationKeys> = {
  Move: 'Move',
  Email: 'Email',
  Filters: 'Filters',
};

export const useIconLabel = () => {
  const { t } = useTranslations(translations);
  return {
    getLabel: (label: string) => {
      const translationKey = labelToKeyMap[label];

      return t(translationKey);
    },
  };
};
